import { combineEpics } from 'redux-observable';
import api from 'api/epics';
import common from 'modules/common/epics';

export default combineEpics(
  api,
  common,
);
